import { request } from 'api';

class EmailVerificationApi {
  static verifyEmail() {
    return request(`users/verifyEmail`, { method: 'post' });
  }
}

export default EmailVerificationApi;